export default "__VITE_ASSET__yMVGky_f__"